import {Axios} from "axios";
import {z} from "zod";
import {ExpandedOrder} from "../../../models/Models";
import {sanitizeOrders} from "./sanitizeOrders";

export const getOrdersByEventRequestSchema = z.object({
  data: z.object({
    eventId: z.number(),
  }),
});
export type GetOrdersByEventRequestPayload = z.infer<
  typeof getOrdersByEventRequestSchema
>;

export type GetOrdersByEventApiResponse = {
  data: {
    data: ExpandedOrder[];
    message: string;
  };
};

export async function getOrdersByEvent(
  requestPayload: GetOrdersByEventRequestPayload,
  axiosInstance: Axios
): Promise<ExpandedOrder[]> {
  getOrdersByEventRequestSchema.parse(requestPayload);
  const response: GetOrdersByEventApiResponse = await axiosInstance.get(
    `event/${requestPayload.data.eventId}/order`
  );
  const sanitizedResponse = sanitizeOrders(response.data.data);

  return sanitizedResponse;
}
